import React from "react";
import "./App.scss";
import Cursor from "./components/cursor/Cursor";
import Main from "./containers/Main";

function App() {
  return (
    <div>
      <Cursor />
      <Main />
    </div>
  );
}

export default App;
